import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useState, useContext, useEffect} from "react";
import AuthContext from "context/AuthContext";
import Offcanvas from "react-bootstrap/Offcanvas";
import {updateListById} from "core/utils/arrays";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import {useTranslation} from "react-i18next";

import axiApi from "ApiCaller";
import { SwalAlertClass } from "core/swalClass";
import ModalDrawZones from "site-apps/distribution/zones/ModalDrawZones";
import MapPoligonManager from "components/maps/MapPoligonManager";
import FormButton from "components/buttons/FormButton";

const FormZone = ({showForm, setShowForm, item, items, setItemsShown}) => {
    const {panel} = useContext(AuthContext);
    const {t: tF} = useTranslation("forms");
    const [formData, setFormData] = useState({...item});
    const [showModalZone, setShowModalZone] = useState(false);
    const [polyline, setPolyline] = useState([]);
    const [showMap, setShowMap] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });

    useEffect(() => {
        setFormData({...item});
        if (item.polylines.length) {
            setPolyline(item.polylines);
        }
        return () => {
            unsubscribeEvent("modaldrawmap:zone", acceptPolyline);
        };
    }, [item]);

    const getCenter = (points) => {
        if (!points || !points.length) return panel.coords;
        let latSum = 0;
        let lngSum = 0;
        points.forEach((p) => {
            latSum += parseFloat(p.lat);
            lngSum += parseFloat(p.lng);
        });
        return [latSum / points.length, lngSum / points.length];
    };

    const polyKey =
        item && item.polylines && item.polylines.length
            ? item.polylines.map((p) => `${p.lat},${p.lng}`).join(";")
            : (item && item.id) || "zone";

    const onChange = (event) => {
        const {name, value} = event.target;
        formData[name] = value;
        setFormData(formData);
    };

    const handleClose = () => {
        setShowForm(false);
    };

    const clickCancel = () => {
        setShowForm(false);
    };

    const onEntered = () => {
        setShowMap(true);
    };
    const onClickAsign = () => {
        setShowModalZone(true);
        subscribeEvent("modaldrawmap:zone", acceptPolyline);
    };
    const acceptPolyline = (e) => {
        if (e.detail.length) {
            setPolyline(e.detail);
            let _zone = {...formData};
            _zone.polylines = e.detail;
            setFormData({..._zone});
            setShowModalZone(false);
        }
        unsubscribeEvent("modaldrawmap:zone", acceptPolyline);
    };

    const onSummit = (e) => {
        setIsLoading(true);
        e.preventDefault();
        let form = new FormData(e.target);
        form.set("polylines", JSON.stringify(polyline));

        axiApi
            .post(`/api/distribution/zone/save/`, form)
            .then((resp) => {
                if (resp.status === 200) {
                    if (formData.id) {
                        items.current.all = updateListById(items.current.all, resp.data.item);
                        let index = items.current.showed.findIndex((item) => item.id === formData.id);
                        items.current.showed[index] = resp.data.item;
                        Alert.success("Guardado", "Guardado correcto");
                    } else {
                        items.current.showed.push(resp.data.item);
                        Alert.success("Creado", "Se ha creado zona correctamente");
                    }
                    items.current.setItem(resp.data.item);
                    items.current.setShowPrev(true);
                    setItemsShown([...items.current.showed]);
                    handleClose();
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
                Alert.error("Error", "Error al guardar la zona");
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <>
            <Offcanvas
                show={showForm}
                onEntered={onEntered}
                onHide={handleClose}
                placement="end"
                backdrop="static"
                style={{width: "40%", fontSize: "15px"}}>
                <Offcanvas.Header className="preview-canvas">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="layer-group" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>{tF("common.zones")}</Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form className="ms-auto" onSubmit={onSummit}>
                        <input type="hidden" name="id" defaultValue={formData.id} />
                        <div className="col-12 mt-4 mb-4">
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                name="name"
                                defaultValue={formData.name}
                                placeholder="Name"
                                onChange={onChange}
                                required
                            />
                        </div>
                        <div className="col-12">
                            <textarea
                                className="form-control"
                                id="description"
                                name="description"
                                defaultValue={formData.description}
                                placeholder="Description"
                                onChange={onChange}
                            />
                        </div>
                        <div className=" col-12 text-end mt-4 mb-4">
                            <button type="button" className="btn btn-outline-primary" onClick={onClickAsign}>
                                <FontAwesomeIcon icon="fa-map" /> Asignar
                            </button>
                        </div>
                        {showMap ? (
                            <MapPoligonManager key={polyKey} id="zone-map" center={getCenter(item.polylines)} zone={formData} />
                        ) : (
                            <></>
                        )}
                        <div className="mt-5 text-end mb-5">
                            <div className="mt-5 d-flex justify-content-end align-right">
                                <button type="button" className="btn btn-secondary" onClick={clickCancel}>
                                    {tF("labels.cancel")}
                                </button>
                                {/* <button type="submit" className="btn btn-primary ms-3">Guardar</button> */}
                                <FormButton
                                    type="submit"
                                    className="btn btn-primary ms-3"
                                    isProcessing={isLoading}
                                    text="Guardar">
                                    {tF("labels.save")}
                                </FormButton>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
            <ModalDrawZones show={showModalZone} setShow={setShowModalZone} zone={formData} subtitle={"Zona: " + item.name} />
        </>
    );
};

export default FormZone;
